import React from 'react';
import { createRoot } from 'react-dom/client';
import Workspace from './components/Workspace';
import './style.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Workspace />
    </React.StrictMode>
  );
}
